import type { Step } from "react-joyride";

export const serviceStandardFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງມາດຕະຖານບໍລິການ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. ມາດຕະຖານບໍລິການຈະຊ່ວຍທ່ານກຳນົດລະບຽບການບໍລິການລູກຄ້າສຳລັບຊ່ອງທາງບໍລິການຕ່າງໆ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ມາດຕະຖານບໍລິການ. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າມາດຕະຖານບໍລິການນີ້ສຳລັບຫຍັງ. ຕົວຢ່າງ: 'ມາດຕະຖານການຕ້ອນຮັບລູກຄ້າ', 'ມາດຕະຖານການຕອບແຊດ'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບມາດຕະຖານບໍລິການນີ້ (ບໍ່ບັງຄັບ). ຄຳອະທິບາຍຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈຈຸດປະສົງຂອງມາດຕະຖານບໍລິການນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-service-channel"]',
    content:
      "ນີ້ແມ່ນການເລືອກຊ່ອງທາງບໍລິການ. ທ່ານຕ້ອງເລືອກຊ່ອງທາງບໍລິການທີ່ມາດຕະຖານບໍລິການນີ້ຈະນຳໃຊ້. ຕົວຢ່າງ: ຕ້ອນຮັບຫນ້າຮ້ານ, ແຊັດອອນລາຍ, Live ຂາຍ. ຊ່ອງນີ້ຈຳເປັນຕ້ອງເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-department"]',
    content:
      "ນີ້ແມ່ນການເລືອກພະແນກ. ທ່ານສາມາດເລືອກພະແນກທີ່ມາດຕະຖານບໍລິການນີ້ຈະນຳໃຊ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, ມາດຕະຖານບໍລິການນີ້ຈະສາມາດນຳໃຊ້ໄດ້ກັບທຸກພະແນກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-position"]',
    content:
      "ນີ້ແມ່ນການເລືອກຕໍາແໜ່ງ. ທ່ານສາມາດເລືອກຕໍາແໜ່ງທີ່ມາດຕະຖານບໍລິການນີ້ຈະນຳໃຊ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, ມາດຕະຖານບໍລິການນີ້ຈະສາມາດນຳໃຊ້ໄດ້ກັບທຸກຕໍາແໜ່ງໃນຜະແນກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-service-stage"]',
    content:
      "ນີ້ແມ່ນການເລືອກໃຊ້ເວລາໃດ. ທ່ານສາມາດເລືອກໃຊ້ເວລາໃດທີ່ມາດຕະຖານບໍລິການນີ້ຈະນຳໃຊ້: ກ່ອນບໍລິການ, ລະຫວ່າງບໍລິການ, ຫຼັງບໍລິການ, ຫຼື ທຸກເວລາ. ຖ້າບໍ່ເລືອກ, ຈະເປັນ 'ທຸກເວລາ' ໂດຍຄ່າເລີ່ມຕົ້ນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-status"]',
    content:
      "ນີ້ແມ່ນການເລືອກສະຖານະ. ທ່ານຕ້ອງເລືອກສະຖານະຂອງມາດຕະຖານບໍລິການ: ໃຊ້ງານ (ສາມາດນຳໃຊ້ໄດ້ທັນທີ), ປັບປຸງ (ເກັບໄວ້ເປັນຮ່າງ, ຍັງບໍ່ພ້ອມ), ຫຼື ເລີກໃຊ້ (ບໍ່ໃຊ້ງານແລ້ວ). ຖ້າບໍ່ເລືອກ, ຈະເປັນ 'ປັບປຸງ' ໂດຍຄ່າເລີ່ມຕົ້ນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-do-items"]',
    content:
      "ນີ້ແມ່ນພາກສິ່ງທີ່ຕ້ອງເຮັດ. ທ່ານສາມາດເພີ່ມລາຍການສິ່ງທີ່ຕ້ອງເຮັດໂດຍກົດປຸ່ມ 'ເພີ່ມລາຍການ'. ສຳລັບແຕ່ລະລາຍການ, ທ່ານສາມາດກຳນົດຂໍ້ຄວາມສິ່ງທີ່ຕ້ອງເຮັດແລະຄຳອະທິບາຍເພີ່ມເຕີມ. ທ່ານຍັງສາມາດລາກເພື່ອປ່ຽນລຳດັບຂອງລາຍການໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-dont-items"]',
    content:
      "ນີ້ແມ່ນພາກສິ່ງທີ່ຫ້າມເຮັດ. ທ່ານສາມາດເພີ່ມລາຍການສິ່ງທີ່ຫ້າມເຮັດໂດຍກົດປຸ່ມ 'ເພີ່ມລາຍການ'. ສຳລັບແຕ່ລະລາຍການ, ທ່ານສາມາດກຳນົດຂໍ້ຄວາມສິ່ງທີ່ຫ້າມເຮັດແລະຄຳອະທິບາຍເພີ່ມເຕີມ. ທ່ານຍັງສາມາດລາກເພື່ອປ່ຽນລຳດັບຂອງລາຍການໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-examples"]',
    content:
      "ນີ້ແມ່ນພາກຕົວຢ່າງການເວົ້າ. ທ່ານສາມາດເພີ່ມຕົວຢ່າງປະໂຫຍກທີ່ສາມາດໃຊ້ໃນສະຖານະການຕ່າງໆ ໂດຍກົດປຸ່ມ 'ເພີ່ມຕົວຢ່າງ'. ສຳລັບແຕ່ລະຕົວຢ່າງ, ທ່ານສາມາດກຳນົດສະຖານະການ, ຕົວຢ່າງປະໂຫຍກ, ແລະຄຳອະທິບາຍເພີ່ມເຕີມ. ທ່ານຍັງສາມາດລາກເພື່ອປ່ຽນລຳດັບຂອງຕົວຢ່າງໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-special-cases"]',
    content:
      "ນີ້ແມ່ນພາກກໍລະນີພິເສດ. ທ່ານສາມາດເພີ່ມກໍລະນີພິເສດທີ່ອາດຈະເກີດຂຶ້ນແລະວິທີການຈັດການໂດຍກົດປຸ່ມ 'ເພີ່ມກໍລະນີພິເສດ'. ສຳລັບແຕ່ລະກໍລະນີພິເສດ, ທ່ານສາມາດກຳນົດຊື່, ວິທີການຈັດການ, ແລະຄຳອະທິບາຍເພີ່ມເຕີມ. ທ່ານຍັງສາມາດລາກເພື່ອປ່ຽນລຳດັບຂອງກໍລະນີພິເສດໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກແລະເປີດໃຊ້ງານ' (ສຳລັບການສ້າງໃໝ່, ສະຖານະໃຊ້ງານ) ຫຼື 'ບັນທຶກເປັນຮ່າງ' (ສະຖານະປັບປຸງ) ເພື່ອບັນທຶກມາດຕະຖານບໍລິການຂອງທ່ານ. ມາດຕະຖານບໍລິການທີ່ບັນທຶກແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ (ຖ້າເປັນສະຖານະໃຊ້ງານ).",
    placement: "top",
  },
];
